module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/25-02ea6c0e2bd742e5acc64f6ea2046bd7.jpg";